import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { Field } from 'redux-form'
import TextField from 'forms/shared/fields/text'
import CheckboxMultipleField from 'forms/shared/fields/checkbox-multiple'
import { FORM_ERROR_CLASS, INPUT_ERROR_CLASS, MERCHANT_FORM_LABEL, MERCHANT_INPUT_CLASS } from 'constants/css-style'
import amenitiesActions from 'actions/amenities/actions'

const Amenities = ({ fetchVenueAmenity, amenities, amenityEditData, action }) => {
  const [amenityForm, setAmenityForm] = useState({ amenities: [] })

  useEffect(() => {
    fetchVenueAmenity()
  }, [])

  useEffect(() => {
    const editDataLoaded = amenityEditData.amenities.length || amenityEditData.feature_1 || amenityEditData.feature_2 || amenityEditData.feature_3
    if ((editDataLoaded && amenities.length) || action === 'add') {
      const defaultForm = { ...amenityForm,
        amenities: amenityEditData.amenities,
        feature_1: amenityEditData.feature_1,
        feature_2: amenityEditData.feature_2,
        feature_3: amenityEditData.feature_3
      }
      setAmenityForm(defaultForm)
    }
  }, [amenityEditData, amenities])


  const renderFeatured = () => {
    const styleMap = {
      1: 'justify-start',
      2: 'justify-center',
      3: 'justify-end'
    }
    return (
      [1, 2, 3].map(index => (
        <div key={index} className={`w-1/3 flex ${styleMap[index]}`}>
          <div className={`w-11/12`}>
            <Field
              type={'text'}
              name={`feature_${index}`}
              label={`Featured Amenity ${index}`}
              groupClassName="my-3 w-full"
              count={60}
              placeholder={'Type in an amenity'}
              labelClassName={MERCHANT_FORM_LABEL}
              inputClassName={MERCHANT_INPUT_CLASS}
              inputErrorClassName={INPUT_ERROR_CLASS}
              errorClassName={FORM_ERROR_CLASS}
              component={TextField}
            />
          </div>
        </div>
      ))
    )
  }

  return (
    <div className="amenities pb-6">
      <p className="font-bold mb-3 text-xl">Space Amenities</p>
      <div className="flex mb-4">
        {renderFeatured()}
      </div>
      <div className="flex flex-wrap">
        <Field name="amenities"
          options={amenities}
          errorClassName="text-red-500 text-xs italic"
          component={CheckboxMultipleField} />
      </div>
    </div>
  )
}

Amenities.propTypes = {
  amenities: PropTypes.array,
  fetchVenueAmenity: PropTypes.func,
  amenityEditData: PropTypes.object,
  action: PropTypes.string
}

const mapStateToProps = ({ amenities, venue }) => ({
  amenities: amenities.venueAmenities,
  amenityEditData: {
    amenities: venue.details.amenities || [],
    feature_1: venue.details.feature_1,
    feature_2: venue.details.feature_2,
    feature_3: venue.details.feature_3
  },
})

const mapDispatchToProps = {
  fetchVenueAmenity: amenitiesActions.fetchVenueAmenity
}

export default connect(mapStateToProps, mapDispatchToProps)(Amenities)
